import styled from "styled-components";
import * as Text from "../../../../../../../common-deprecated/styles/v2/toyota/utilities/Text";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";

export const EnginesWrapper = styled.div`
    position: relative;
    order: 4;
    width: calc(100% + 64px);
    height: 48px;
    margin: 0 -${theme.space[4]}px;
    overflow: hidden;

    @media ${getBreakpoint("up", "md")} {
        overflow: visible;
    }

    @media ${getBreakpoint("up", "xl")} {
        height: 0;
    }

    &[aria-expanded="true"] {
        height: auto;
    }
`;

export const EngineListContent = styled.div`
    display: flex;
    height: 0;
    gap: ${theme.space[3]}px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;

    @media ${getBreakpoint("up", "md")} {
        flex-wrap: wrap;
        overflow-x: visible;
    }

    @media ${getBreakpoint("up", "lg")} {
        gap: ${theme.space[4]}px;
    }
`;

export const EngineListSliderNavigation = styled.div`
    display: flex;
    justify-content: space-between;
    gap: ${theme.space[1]}px;
`;

export const EngineListSliderButton = styled.button`
    display: block;
    width: 32px;
    height: 32px;
    color: ${theme.colors.primaryWhite};
    background-color: ${theme.colors.primaryBlack};
    border-radius: 50%;

    &:disabled {
        opacity: 0.75;
    }
`;

export const EngineListHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${theme.space[2]}px;

    @media ${getBreakpoint("up", "md")} {
        display: none;
    }
`;

export const EngineList = styled.div`
    max-height: 0;
    padding: ${theme.space[3]}px;
    background-color: ${theme.colors.grey1};
    transform-origin: top;
    transition: max-height 0.55s ease-out;

    @media ${getBreakpoint("up", "xl")} {
        position: relative;
        top: ${theme.space[4]}px;
        padding: 0;
    }

    &[aria-expanded="true"] {
        max-height: 2500px;

        ${EngineListContent} {
            height: auto;
        }

        @media ${getBreakpoint("up", "lg")} {
            padding: ${theme.space[5]}px ${theme.space[4]}px;
        }
    }
`;

export const EngineButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin: 0;
    padding: 0 2.4rem;
    gap: ${theme.space[2]}px;
    line-height: 4.8rem;
    background-color: ${theme.colors.primaryBlack};
    transition: color 0.24s ease-in;

    ${Text.Button} {
        color: ${theme.colors.primaryWhite};
    }

    @media ${getBreakpoint("up", "xl")} {
        position: absolute;
        top: -18px;
        left: 0;
        width: auto;

        html[dir="rtl"] & {
            left: auto;
            right: 0;
        }
    }

    &[aria-pressed="true"] {
        background-color: ${theme.colors.grey1} !important;
        opacity: 1 !important;

        ${Text.Button} {
            color: ${theme.colors.primaryBlack} !important;
        }
    }
`;
